import { render, staticRenderFns } from "./data.vue?vue&type=template&id=37dce411"
import script from "./data.vue?vue&type=script&lang=js"
export * from "./data.vue?vue&type=script&lang=js"
import style0 from "./data.vue?vue&type=style&index=0&id=37dce411&prod&lang=less&scope=true"
import style1 from "./data.vue?vue&type=style&index=1&id=37dce411&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports